import { Injectable } from '@angular/core';
import { RxntIcon } from './rxnt-icon.model';

@Injectable()
export class RxntIconService {
  iconClassMap: Map<RxntIcon, string>;

  constructor() {
    this.iconClassMap = new Map<RxntIcon, string>();
    this.iconClassMap.set(RxntIcon.None, '');
    this.iconClassMap.set(RxntIcon.Refresh, 'refresh');
    this.iconClassMap.set(RxntIcon.Print, 'print');
    this.iconClassMap.set(RxntIcon.Export, 'download');
    this.iconClassMap.set(RxntIcon.Add, 'add');
    this.iconClassMap.set(RxntIcon.Edit, 'edit');
    this.iconClassMap.set(RxntIcon.Close, 'close');
    this.iconClassMap.set(RxntIcon.Menu, 'overflow');
    this.iconClassMap.set(RxntIcon.FirstPage, 'chevrondoubleleft');
    this.iconClassMap.set(RxntIcon.PrevPage, 'chevronleft');
    this.iconClassMap.set(RxntIcon.NextPage, 'chevronright');
    this.iconClassMap.set(RxntIcon.LastPage, 'chevrondoubleright');
    this.iconClassMap.set(RxntIcon.Custom, 'rxnt');
    this.iconClassMap.set(RxntIcon.ChevronDown, 'chevrondown');
    this.iconClassMap.set(RxntIcon.Pdf, 'pdffile');
    this.iconClassMap.set(RxntIcon.Lock, 'lock');
    this.iconClassMap.set(RxntIcon.Unlock, 'unlock');
    this.iconClassMap.set(RxntIcon.Import, 'upload');
    this.iconClassMap.set(RxntIcon.ShowPassword, 'isnotblank'); // TODO: NPM-8934: Update to support 'eyeopen' & 'eyeclose'
    this.iconClassMap.set(RxntIcon.HidePassword, 'isblank'); // TODO: NPM-8934: Update to support 'eyeopen' & 'eyeclose'
  }

  getIconClass(icon: RxntIcon): string {
    return this.iconClassMap.get(icon) || '';
  }
}
